import { ReactNode } from "react";

import { AuthCard } from "@/components/ui/AuthCard";
import { cn } from "@/lib/cn";

/**
 * The surface of an account screen: the front door's auth card, widened to the screen's 576px
 * column. Its own children set the rhythm (`flex flex-col gap-6`), so the card adds no spacing.
 */
export const AccountCard = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => <AuthCard className={cn("max-w-none space-y-0", className)}>{children}</AuthCard>;
